import React, { useState, useEffect } from 'react';
import ServerService from '../services/Server';

type ImageWithAuthProps = {
    src: string;
}

const ImageWithAuth: React.FC<ImageWithAuthProps> = (props) => {

    const server = new ServerService();
    // Components refs
    const img: React.Ref<HTMLImageElement> = React.createRef();
    const [imgc,setImgc] = useState(null)

    // Load data
    useEffect(() => {
        fetch(`${props.src}`,server.getRequest())
        .then(r => r.blob())
        .then(blob => {
            var reader = new FileReader();
            reader.onload = function() {
                var b64 = reader.result.toString()
                // console.log("src:"+b64)
                // console.log("img.current:"+img.current)
                if (img.current != null) {
                    img.current!.src = b64;
                } else {
                    setImgc(b64)
                }
            }
            reader.readAsDataURL(blob);
        })
    }, [])

    useEffect(() => {
        if (img.current != null) {
            img.current!.src = imgc;
        }
    },[imgc])

    return (
        <img src={""} alt={"Loading..."} ref={img}/>
    )

}

export default ImageWithAuth;